export default {
  title: '座位安排',
  description: '为每个会议场次绑定对应的座位场地，并导入该场次的参会人员名单，随后可进入「调整座位」进行座位编排。',
  addButton: '添加场地安排',
  addTitle: '添加座位安排',
  index: '序号',
  meetingScope: '会议场次',
  meetingPlaceholder: '请选择会议场次',
  wholeActivity: '整场活动（不区分会议场次）',
  wholeActivityHint: '没有单独会议场次时，可选择“整场活动（不区分会议场次）”。',
  layout: '座位场地',
  scrollVenue: '左右滑动选择场地',
  prevVenue: '向左查看场地',
  nextVenue: '向右查看场地',
  createLayout: '创建座位场地',
  createLayoutHint: '新增场地并布置座位',
  emptyLayoutPreview: '空场地',
  emptyLayoutTypes: '暂无席位类型',
  layoutThumbnailAria: '{name}场地缩略图',
  approvedPeople: '报名已通过人员',
  approvedPeopleHint: '选择会议场次或“整场活动”后，系统会读取对应范围内审核状态为“已通过”的报名人。',
  approvedPeopleWholePrefix: '整场活动已通过报名人员',
  approvedPeopleMeetingPrefix: '该场次已通过报名人员',
  approvedPeopleCountSuffix: '位',
  approvedStatus: '已通过',
  loadingRoster: '正在读取报名人员…',
  rosterLoadFailed: '报名人员读取失败，请稍后重试',
  noApprovedPeopleWhole: '该活动暂无报名已通过的人员',
  noApprovedPeopleMeeting: '该场次暂无报名已通过的人员',
  rosterSourceLabel: '人员名单来源',
  rosterSourceHint: '可选择读取本场活动/会议已通过的报名名单，或下载模板后导入名单。',
  rosterSourceRegistrationWhole: '按整场活动报名名单',
  rosterSourceRegistrationMeeting: '按本场会议报名名单',
  rosterSourceImported: '按导入名单',
  importedPeoplePrefix: '已导入人员',
  importedPeopleCountSuffix: '位',
  importedTag: '导入人员',
  rosterEmptyImported: '尚未导入名单，请下载模板填写后上传。',
  clearImported: '清空导入名单',
  previewTruncated: '仅展示前 {count} 位，共 {total} 位',
  types: '席位类型',
  seatCount: '· {count} 座',
  seatCountLabel: '座位数',
  assigned: '已分配',
  emptySeats: '空置',
  roster: '参会名单',
  rosterCount: '共 {count} 人',
  rosterSource: '名单来源',
  registrationRoster: '按本场会议报名名单',
  registrationRosterHint: '系统在下一次名单配置阶段读取已通过报名人员。',
  rearrange: '重新安排',
  adjust: '调整座位',
  rearrangeTitle: '重新安排',
  rearrangeSessionHint: '会议场次已固定，重新安排仅更换座位场地，场次不可修改。',
  rearrangeRosterHint: '重新安排会清空原有参会名单与座位分配，并按下面选择的名单来源重新生成。',
  rearrangeConfirm: '原有参会名单与座位分配数据将被清空，确认后按新的名单与场地重新分配座位。是否继续？',
  rearrangeSuccess: '座位安排已更新',
  complete: '完成',
  saving: '保存中…',
  createSuccess: '座位安排创建成功',
  emptyList: '暂无座位安排',
  noLayouts: '暂无可选座位场地',
  autoCopy: '自动复制',
  lastSaved: '最后保存时间',
  notSaved: '尚未保存',
  activityRequired: '请先创建活动'
}
